/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_fS as fS,
  rec_wr as wr,
} from "../../runtime/index.jsx";
export function Componente_BS_66_83(e) {
  let t = (0, ReactCompiler.c)(14),
    { valor: n, pendiente: r, onPedir: i } = e,
    a;
  t[0] !== i || t[1] !== r
    ? ((a = () => !r && i()), (t[0] = i), (t[1] = r), (t[2] = a))
    : (a = t[2]);
  let o = !!r,
    s = r
      ? `Ya hay un pedido esperando respuesta`
      : `Tocá para pedir otra fecha`,
    c = n ? `text-(--text-h)` : `text-(--text)`,
    l;
  t[3] === n
    ? (l = t[4])
    : ((l = n ? fS(n) : `Sin fecha`), (t[3] = n), (t[4] = l));
  let u;
  t[5] !== c || t[6] !== l
    ? ((u = <span className={c} children={l} />),
      (t[5] = c),
      (t[6] = l),
      (t[7] = u))
    : (u = t[7]);
  let d;
  t[8] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((d = (0, JSXRuntime.jsx)(wr, {
        className: `h-4 w-4 shrink-0 text-(--text)`,
      })),
      (t[8] = d))
    : (d = t[8]);
  let f;
  return (
    t[9] !== a || t[10] !== o || t[11] !== s || t[12] !== u
      ? ((f = (
          <button
            type={`button`}
            onClick={a}
            disabled={o}
            title={s}
            className={`${Lo} flex items-center justify-between text-left disabled:opacity-70`}
            children={[u, d]}
          />
        )),
        (t[9] = a),
        (t[10] = o),
        (t[11] = s),
        (t[12] = u),
        (t[13] = f))
      : (f = t[13]),
    f
  );
}
